import clsx from "clsx";
import { Link } from "react-router-dom";
import { Fragment, useRef, useState } from "react";
import LiveChat from "pages/support/LiveChat";
import { MenuLink } from "components/atoms/MenuLink";
import { Subtitle } from "components/atoms/Text";
import LanguageListBox from "components/organism/LanguageListBox";
import { connect, useDispatch } from "react-redux";
import { updateIdMenu } from "state/proxy.action";

const Footer = ({ heroRefs, updateMenu }) => {
    const liveChatRefs = useRef(null);
    const openChatRefs = useRef(null);
    const [currentState, setCurrentState] = useState(false);

    const dispatch = useDispatch();

    const ScrollToHeroTopRefs = (ref) => {
        window.scrollTo({
            top: ref.offsetTop,
            left: 0,
            behavior: "smooth"
        });
    };

    const ProxyFn = (ref, idMenu) => {
        ScrollToHeroTopRefs(ref);
        dispatch(updateMenu(idMenu));
    };

    return (
        <Fragment>
            <LiveChat footerChatRefs={liveChatRefs} passLiveChatRefs={openChatRefs} setCurrentState={setCurrentState} />
            {currentState ? <img onClick={() => openChatRefs.current?.closeModal()} src={"/images/universal/chat-open.svg"}
                className="fixed hover:cursor-pointer z-[100] w-14 h-14 bottom-8 right-8 phone:bottom-4 phone:right-4" alt="chat" /> :
                <img onClick={() => openChatRefs.current?.openModal()} src={"/images/universal/chat.svg"}
                    className="fixed hover:cursor-pointer z-[100] w-14 h-14 bottom-8 right-8 phone:bottom-4 phone:right-4" alt="chat" />}
            <section className="w-full bg-neutral-10 tablet:pb-[80px] phone:pb-12 pb-[96px]">
                <div className="max-w-[1440px] mx-auto flex flex-col md:flex-row justify-between px-6 tablet:px-8 desktop:px-[120px]">
                    <div className="pt-16 phone:pt-12">
                        <Link onClick={() => ScrollToHeroTopRefs(heroRefs.current)} to="/">
                            <img src="/images/universal/anonymousproxies.svg" width="276px" height="52px" alt="anonymous proxies" />
                        </Link>
                        <Subtitle classNames="pt-6 tablet:max-w-[308px] desktop:max-w-[312px] phone:!text-[16px]">We offer highly secure, (Dedicated or Shared / Residential or Non-Residential) SOCKSv5 and Proxies.</Subtitle>
                        <LanguageListBox />
                    </div>
                    <div className="grid phone:grid-cols-2 md:grid-cols-3 gap-6 phone:gap-y-[32px] tablet:gap-x-[56px] desktop:gap-x-[72px] phone:mt-10 mt-[72px]">
                        <div className="flex flex-col space-y-4">
                            <h3 className="font-semibold phone:text-[16px] text-lg text-primary-dark">Our Products</h3>
                            <Link to="/proxy" onClick={() => ProxyFn(heroRefs.current, 1)}>
                                <button className={clsx(
                                    "font-normal relative z-30 phone:text-[14px] text-[16px] tracking-text phone:leading-[23.8px] leading-[27.2px]",
                                    "hover:cursor-pointer text-neutral-50"
                                )}>Residential Proxy</button>
                            </Link>
                            <Link to="/proxy" onClick={() => ProxyFn(heroRefs.current, 2)}>
                                <button className={clsx(
                                    "font-normal relative z-30 phone:text-[14px] text-[16px] tracking-text phone:leading-[23.8px] leading-[27.2px]",
                                    "hover:cursor-pointer text-neutral-50"
                                )}>HTTP Proxy</button>
                            </Link>
                            <p className={clsx(
                                "font-normal relative z-30 phone:text-[14px] text-[16px] tracking-text phone:leading-[23.8px] leading-[27.2px]",
                                "hover:cursor-pointer text-neutral-50",
                            )}>HTTPS Proxy</p>
                            <Link to="/proxy" onClick={() => ProxyFn(heroRefs.current, 4)}>
                                <button className={clsx(
                                    "font-normal relative z-30 phone:text-[14px] text-[16px] tracking-text phone:leading-[23.8px] leading-[27.2px]",
                                    "hover:cursor-pointer text-neutral-50"
                                )}>SOCKSV5 Proxy</button>
                            </Link>
                            <Link to="/proxy" onClick={() => ProxyFn(heroRefs.current, 5)}>
                                <button className={clsx(
                                    "font-normal relative z-30 phone:text-[14px] text-[16px] tracking-text phone:leading-[23.8px] leading-[27.2px]",
                                    "hover:cursor-pointer text-neutral-50"
                                )}>Dedicated Proxy</button>
                            </Link>
                            <Link to="/proxy" onClick={() => ProxyFn(heroRefs.current, 3)}>
                                <button className={clsx(
                                    "font-normal relative z-30 phone:text-[14px] text-[16px] tracking-text phone:leading-[23.8px] leading-[27.2px]",
                                    "hover:cursor-pointer text-neutral-50"
                                )}>Shared Proxy</button>
                            </Link>
                            <Link to="/proxy" onClick={() => ProxyFn(heroRefs.current, 6)}>
                                <button className={clsx(
                                    "font-normal relative z-30 phone:text-[14px] text-[16px] tracking-text phone:leading-[23.8px] leading-[27.2px]",
                                    "hover:cursor-pointer text-neutral-50"
                                )}>Amazon Proxy</button>
                            </Link>
                            <Link to="/proxy" onClick={() => ProxyFn(heroRefs.current, 7)}>
                                <button className={clsx(
                                    "font-normal relative z-30 phone:text-[14px] text-[16px] tracking-text phone:leading-[23.8px] leading-[27.2px]",
                                    "hover:cursor-pointer text-neutral-50"
                                )}>LinkedIn Proxy</button>
                            </Link>
                        </div>
                        <div className="flex flex-col space-y-4">
                            <h3 className="font-semibold phone:text-[16px] text-lg text-primary-dark">Resources</h3>
                            <MenuLink routeDestination="/resources/privacy-policy">Privacy Policy</MenuLink>
                            <MenuLink routeDestination="/resources/terms-of-service">Terms of Service</MenuLink>
                            <MenuLink routeDestination="/resources/refunds">Refunds</MenuLink>
                            <MenuLink routeDestination="/resources/restrictions">Restrictions</MenuLink>
                            <MenuLink routeDestination="/affiliates">Affiliates</MenuLink>
                            <MenuLink routeDestination="/dashboard">Dashboard</MenuLink>
                        </div>
                        <div className="flex flex-col space-y-4">
                            <h3 className="font-semibold phone:text-[16px] text-lg text-primary-dark">Support</h3>
                            <MenuLink routeDestination="/support/contact">Contact Us</MenuLink>
                            <button onClick={() => liveChatRefs.current.openModal()} className={clsx(
                                "font-normal text-left relative z-30 phone:text-[14px] text-[16px] tracking-text phone:leading-[23.8px] leading-[27.2px]",
                                "hover:cursor-pointer text-neutral-50"
                            )}>Live Chat</button>
                            <MenuLink routeDestination="/support/knowledge-base">Knowledge Base</MenuLink>
                            <MenuLink routeDestination="/support/news">News & Articles</MenuLink>
                        </div>
                    </div>
                </div>
            </section>
            <section className="w-full text-center flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0 px-6 tablet:px-8 desktop:px-20 py-8 bg-neutral-10 border-t border-[#EBEBEB]">
                <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 items-center md:space-x-8">
                    <p className="text-neutral-50 font-normal phone:text-[16px] text-md leading-[19.2px]">&copy; 2022, anonymous-proxies.net</p>
                    <div className="flex items-center space-x-8 phone:!mt-[24px]">
                        <MenuLink classNames="phone:!leading-[19.2px]" routeDestination="/resources/terms-of-service">Terms</MenuLink>
                        <p className={clsx(
                            "font-normal relative z-30 phone:text-[14px] text-[16px] tracking-text phone:leading-[19.2px] leading-[27.2px]",
                            "hover:cursor-pointer text-neutral-50",
                        )}>Cookies</p>
                        <MenuLink classNames="phone:!leading-[19.2px]" routeDestination="/resources/privacy-policy">Privacy Policy</MenuLink>
                    </div>
                </div>
                <div className="flex items-center justify-between space-x-6 phone:!mt-[32px]">
                    <img src="/icons/social/linkedin.svg" width="20px" height="20px" alt="linkedin" />
                    <img src="/icons/social/twitter.svg" width="20px" height="20px" alt="twitter" />
                    <img src="/icons/social/facebook.svg" width="20px" height="20px" alt="facebook" />
                </div>
            </section>
        </Fragment >
    );
};

const mapStateToProps = (state) => {
    return {
        idMenu: state.proxy.idMenu
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateMenu: (id) => dispatch(updateIdMenu(id))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);